function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState } from 'react';
import { uid } from 'react-uid';
import PropTypes from 'prop-types';
import Alert from './Alert';
import Box from './Box';
import GalleryImage from './GalleryImage';
import GalleryImageSkeleton from './GalleryImageSkeleton';
import GalleryViewer from './GalleryViewer';
import StyledGalleryGrid from './Gallery.styled';
function Gallery(_ref) {
  var images = _ref.images,
    loading = _ref.loading,
    infoText = _ref.infoText,
    renderItem = _ref.renderItem;
  var _useState = useState(false),
    viewing = _useState[0],
    setViewing = _useState[1];
  var _useState2 = useState(0),
    viewingIndex = _useState2[0],
    setViewingIndex = _useState2[1];
  var handleImagePreview = function handleImagePreview(index) {
    setViewingIndex(index);
    setViewing(true);
  };
  var handleImagePreviewClose = function handleImagePreviewClose() {
    setViewingIndex(0);
    setViewing(false);
  };
  var handleImagePreviewChange = function handleImagePreviewChange(index) {
    setViewingIndex(index);
  };
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(StyledGalleryGrid, null, renderItem && images.map(function (image, i) {
    return renderItem(_extends({
      onClick: function onClick() {
        return handleImagePreview(i);
      }
    }, image), i);
  }), !renderItem && images.map(function (image, i) {
    return /*#__PURE__*/React.createElement(GalleryImage, {
      key: uid(image, i),
      src: image.thumb,
      onClick: function onClick() {
        return handleImagePreview(i);
      }
    });
  })), loading && /*#__PURE__*/React.createElement(StyledGalleryGrid, null, /*#__PURE__*/React.createElement(GalleryImageSkeleton, {
    amount: 7
  })), infoText && /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(Alert, {
    color: "info",
    variant: "standard"
  }, infoText)), /*#__PURE__*/React.createElement(GalleryViewer, {
    images: images,
    open: viewing,
    currentIndex: viewingIndex,
    onClose: handleImagePreviewClose,
    onChange: handleImagePreviewChange
  }));
}
Gallery.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * List of images
   */
  images: PropTypes.arrayOf(PropTypes.shape({
    path: PropTypes.string.isRequired,
    thumb: PropTypes.string.isRequired,
    name: PropTypes.string,
    type: PropTypes.string.isRequired
  })),
  /**
   *
   */
  infoText: PropTypes.node,
  /**
   *
   */
  loading: PropTypes.bool,
  /**
   *
   */
  renderItem: PropTypes.func
} : {};
Gallery.defaultProps = {
  images: [],
  infoText: undefined,
  loading: false,
  renderItem: undefined
};
export default Gallery;